import React from 'react'
import { makeStyles, InputAdornment } from '@material-ui/core'
import * as Yup from 'yup'

import {
  // FIELD_REQUIRED,
  SidePanel,
  Typography,
  Form,
  FormikSelect,
  FormikRadioGroup,
  FormikTextField,
  Button,
  FormikImageFileField,
} from 'src/modules/ui'
import { Formik } from 'formik'
import { FormActions } from '../../../../auth'

const unitValueOptions = [
  { value: 'grams', label: 'grams' },
  { value: 'ml', label: 'ml' },
]

const useStyles = makeStyles(theme => ({
  sidePanelContainer: {
    flexShrink: 0,
    marginLeft: 0,
    marginTop: theme.spacing(4),
    width: 'auto',
    [theme.breakpoints.up('desktop')]: {
      marginTop: theme.spacing(9),
      marginLeft: theme.spacing(4),
      width: 250,
    },
  },
  sidePanelGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
  },
}))

const validationSchema = Yup.object().shape({
  // batch: Yup.string().required(FIELD_REQUIRED),
  // category: Yup.string().required(FIELD_REQUIRED),
  // batchSize: Yup.number().typeError('Must be a number e.g. (1)'),
  // batchPortions: Yup.number().typeError('Must be a number e.g. (10)'),
  // menuPrice: Yup.number().typeError('Must be a number e.g. (10)'),
})

const mapCategoriesToOptions = category => {
  return category.map(({ id, name }) => ({ value: id, label: name }))
}

const RecipeSummarySidePanel = ({ children, categories, onSubmit, recipe }) => {
  const classes = useStyles()

  const initialValues = {
    category:
      recipe && recipe.categories.length > 0
        ? recipe.categories.map(c => c.category.id)
        : [],

    unitSelect: recipe ? recipe.unit : 'grams',
    menuPrice: recipe ? recipe.menuPrice : null,
    batchPortions: recipe ? recipe.batchPortions : undefined,
    batchSize: recipe ? recipe.batchSize : undefined,
    batch: recipe ? recipe.recipeType : 'finished_recipe',
  }

  return (
    <div className={classes.sidePanelContainer}>
      <SidePanel>
        <div className={classes.sidePanelGroup}>
          <div>
            <Typography variant="h5">Summary</Typography>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
              enableReinitialize
            >
              {({ handleSubmit, isSubmitting }) => (
                <>
                  <Form>
                    <FormikImageFileField
                      name="recipePhoto"
                      margin="normal"
                      label="Recipe Photo"
                    />
                    <FormikSelect
                      label="Category"
                      margin="normal"
                      name="category"
                      fullWidth
                      multiple={true}
                      options={mapCategoriesToOptions(categories)}
                    />
                    <FormikSelect
                      label="Recipe Type"
                      margin="normal"
                      name="batch"
                      fullWidth
                      options={[
                        { label: 'Recipe', value: 'finished_recipe' },
                        {
                          label: 'Recipe Component',
                          value: 'recipe_component',
                        },
                      ]}
                    />

                    <Typography variant="h5" style={{ marginTop: '1rem' }}>
                      Batch
                    </Typography>
                    <FormikTextField
                      label="Batch Weight"
                      margin="normal"
                      name="batchSize"
                      type="text"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    />
                    <FormikRadioGroup
                      fullWidth
                      key="unit"
                      label=""
                      margin="normal"
                      name="unitSelect"
                      options={unitValueOptions}
                      table={true}
                    />
                    <FormikTextField
                      label="Batch Portions"
                      margin="normal"
                      name="batchPortions"
                      type="text"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    />
                    <Typography variant="h5" style={{ marginTop: '1rem' }}>
                      Pricing
                    </Typography>
                    <FormikTextField
                      label="Menu Price"
                      margin="normal"
                      name="menuPrice"
                      type="text"
                      fullWidth
                      placeholder="0.00"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">£</InputAdornment>
                        ),
                      }}
                    />
                    <FormActions>
                      <Button
                        color="primary"
                        onClick={handleSubmit}
                        isLoading={isSubmitting}
                        size="large"
                        fullWidth
                      >
                        {recipe ? 'Update Recipe' : 'Create Recipe'}
                      </Button>
                    </FormActions>
                  </Form>
                </>
              )}
            </Formik>
          </div>
        </div>

        {children}
      </SidePanel>
    </div>
  )
}

export default RecipeSummarySidePanel
